import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button, ButtonContainer } from 'components/button';
import { deleteVideoAction } from 'common/actions';
import { uploadResetAction } from 'pages/upload.page/actions';
import { hideDialogAction } from 'components/redux-dialog/actions';

export const UPLOAD_FAILED_DIALOG = 'UploadFailedDialog';

export const UploadFailedDialog = connect(false, (dispatch, props) => ({
  handleFailedUpload: () => {
    dispatch(deleteVideoAction(props.video.id));
    dispatch(uploadResetAction());
    dispatch(hideDialogAction(UPLOAD_FAILED_DIALOG));
  },
}))(({ handleFailedUpload }) => {
  const { t } = useTranslation();
  return (
    <DialogDecorated dialogName={UPLOAD_FAILED_DIALOG} closeDialogCb={() => handleFailedUpload()}>
      <DialogTitle>
        <h2>{t('upload_failed')}</h2>
      </DialogTitle>
      <DialogBody>
        <div className="ct-stp2-dialog-body upload-failed-text">
          <p>{t('upload_failed_text')}</p>
        </div>
      </DialogBody>
      <DialogFooter>
        <ButtonContainer>
          <Button onClick={() => handleFailedUpload()}>{t('try_again')}</Button>
        </ButtonContainer>
      </DialogFooter>
    </DialogDecorated>
  );
});

UploadFailedDialog.propTypes = {
  video: PropTypes.object,
};
